import { render, staticRenderFns } from "./ShareACopy.vue?vue&type=template&id=7ae3e96e&scoped=true&"
import script from "./ShareACopy.vue?vue&type=script&lang=js&"
export * from "./ShareACopy.vue?vue&type=script&lang=js&"
import style0 from "./ShareACopy.vue?vue&type=style&index=0&id=7ae3e96e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae3e96e",
  null
  
)

export default component.exports